import React from "react";

import styles from "./zeroData.module.css";
import CircleInfoIcon from "../../assets/icons/circle-info.svg";

const ZeroData = ({ children }) => {
  return (
    <div className={styles.zeroData}>
      <img src={CircleInfoIcon} alt="Zero Data" />

      {children}
    </div>
  );
};

export default ZeroData;
